import React, {useContext} from 'react';
import {
    Box,
    Grid,
    Typography
} from "@material-ui/core";
import Dropzone from 'react-dropzone'
import {AppContext} from "../../utils/appContext";
import {PlusCircle} from "@vectopus/atlas-icons-react";
import {makeStyles} from "tss-react/mui";
import {useTranslation} from "react-i18next";


export const DropZoneHelpForm = () => {

    const useStyles = makeStyles()((theme) => {
        return {
            dropArea: {
                cursor: 'pointer',
                height: '100%',
                border: '2px dashed #2357D080',
                textAlign: 'center',
                padding: 20,
                background: '#2C59C90D',
                minHeight: 150,
                '& p': {
                    fontWeight: 'bold',
                    fontSize: 16,
                    textAlign: 'center',
                    fontFamily: 'Jost'
                }
            },
            or: {
                display: 'flex',
                width: '30%',
                margin: 'auto',
                fontFamily: 'Jost',
                '& hr': {
                    width: 100,
                    border: '1px solid #93A9C3',
                    height: 0
                }
            },
            iconContainer: {
                borderRadius: '50%',
                backgroundColor: '#FFF',
                width: 72,
                height: 72,
                margin: 'auto',
                padding: '0!important',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }
        }
    });

    const {classes} = useStyles();
    const {t} = useTranslation();
    const appContext = useContext(AppContext);

    const addAttachment = (files: File[]) => {
        files.forEach((file: File) => appContext.helpForm.Attachment.push(file))
        appContext.setHelpForm({...appContext.helpForm})
    }

    const removeFromLists = (index: any) => {
        appContext.helpForm.Attachment.splice(index, 1);
        appContext.setHelpForm({...appContext.helpForm})
    }


    return (
        <Grid container
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              spacing={3}
        >
            <Grid item xs={12}>
                <Box mt={3}>
                    <Dropzone onDrop={acceptedFiles => addAttachment(acceptedFiles)}
                              // accept={"image/png, image/jpeg, image/jpg, image/webp, text/plain, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/octet-stream, video/mp4, video/mpeg, video/x-msvideo, video/webm, video/quicktime"}
                              multiple={true}
                    >
                        {({getRootProps, getInputProps}) => (
                            <section>
                                <div className={classes.dropArea} {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <Box p={0} className={classes.iconContainer}>
                                        <PlusCircle size={40} color={'#2357D0'}/>
                                    </Box>
                                    <Box mt={2}>
                                        <Typography variant={'h5'} component={'h5'}>{t('allega_file')}</Typography>
                                    </Box>
                                </div>

                                {appContext.helpForm.Attachment.length > 0 && (
                                    <Box pt={3}>
                                        <aside>
                                            <h4>Files</h4>
                                            <ul style={{listStyle: 'none', padding: 0}}>
                                                {appContext.helpForm.Attachment.map((file: any, index: number) => (
                                                    <li key={index} style={{
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>{file.path} - {file.size} bytes <i className={'las la-times'}
                                                                                          style={{
                                                                                              color: 'red',
                                                                                              fontSize: 18,
                                                                                              marginLeft: '10px'
                                                                                          }}
                                                                                          onClick={() => removeFromLists(index)}></i>
                                                    </li>))}
                                            </ul>
                                        </aside>
                                    </Box>
                                )}
                            </section>
                        )}
                    </Dropzone>
                </Box>

            </Grid>


        </Grid>
    )
};
